import { AppState } from '~src/app/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { updateDataFreshnessPolicy } from '~src/dataAcceleration/actions/UpdateDataFreshnessPolicyAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { WorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { IEditDataFreshnessPolicyAction } from '~src/ts/ServerApi/types/actionNames';

export const UpdateDataFreshnessPolicyEntityAction: IEntityAction<IContentInfo, IEditDataFreshnessPolicyAction> = {
  name: EntityActionNames.UpdateDataFreshnessPolicy,
  translateName: Messages.editDataFreshnessPolicyButtonText,
  isVisible: (targetItems: IContentInfo[], state: AppState, availableAction: IEditDataFreshnessPolicyAction) => {
    return FeatureFlags.queryPipelineDataFreshnessUISupported &&
      targetItems && targetItems.length === 1 &&
      targetItems[0].contentType === WorkbookContentType.name &&
      availableAction && availableAction.editDataFreshnessPolicy;
  },
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]) => {
    return updateDataFreshnessPolicy(targetItems);
  }
};
